import { makeAuthenticatedRequest, parseErrorResponse } from './client';

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const exportApi = {
  downloadExcel: async (type) => {
    // type: 'customers' or 'enquiries'
    const path = type === 'customers' ? 'customers-full' : type;
    const response = await makeAuthenticatedRequest(`/api/v1/exports/${path}`);
    if (!response.ok) throw new Error(await parseErrorResponse(response));
    const blob = await response.blob();
    const stamp = new Date().toISOString().slice(0, 10);
    downloadBlob(blob, `${type}_${stamp}.xlsx`);
  },
};
